import { isFilterSingleMandatory } from '@/features/filter/filter-data/service/filter-data-service';
import { useFilterDataV1Mutation } from '@/features/filter/filter-data/use-filter-data-mutation';
import QuickFilter from '@/features/filter/quick-filter/quick-filter/quick-filter';
import { useActiveQuickFilterCollection } from '@/features/filter/quick-filter/quick-filter/quick-filter-state';
import useQuickFilter from '@/features/filter/quick-filter/use-quick-filter';
export default function QuickFilterContainerDesktop() {
    const { deselectFilterGroup } = useQuickFilter();
    const { resetFilter } = useFilterDataV1Mutation();

    const activeNonMandatoryQuickFilterCollection = useActiveQuickFilterCollection().filter(
        (quickFilter) => !isFilterSingleMandatory(quickFilter.type),
    );

    if (activeNonMandatoryQuickFilterCollection.length === 0) {
        return null;
    }
    return (
        <QuickFilter
            chipLargeIcons={true}
            chipRounded={false}
            chipSize={'S'}
            closeButtonSize={10}
            fullWidth={false}
            isScrollable={false}
            onDeselect={deselectFilterGroup}
            onFilterReset={resetFilter}
            onSelect={deselectFilterGroup}
            padding={'p-0'}
            quickFilterCollection={activeNonMandatoryQuickFilterCollection}
            showResetButton={true}
            wrap={'wrap'}
        />
    );
}
